class If_True_False {
    static path = 'logic/if-true-false';

    constructor(mutator){
        this.addInput("Data", "");
        this.addOutput("True/False", "boolean");
        this.bgcolor = '#9fe2fc';
        this.title = 'If True/False';
        this.desc = 'Detect is the is true or false';
        this.properties = {selected: ''};

        this.addWidget("combo","",this.properties.selected,(v) => {
            this.properties.selected = v;
            if(v !== '') {
                this.title = 'If ' + v;
                this.outputs[0].name = 'If ' + v
            } else {
                this.title = 'If True/False'
                this.outputs[0].name = 'True/False'
            }
            this.triggerSlot(0, v);
        },{ property: "selected", values: ['True', 'False'] } );
    }
}

module.exports = If_True_False
